<template>
    <div class="message gallery-image-card" :class="{ opac: !current }" @click="$emit('click')">
        <div class="card">
            <div class="card-image" v-if="card.imageUrls && card.imageUrls.length > 0">
                <div class="image-wrapper">
                    <ssr-carousel
                        class="image-slider"
                        :loop="false"
                        :show-arrows="current"
                        :show-dots="current"
                        :slides-per-page="card.imageUrls.length > 4 ? 2 : 1"
                        :gutter="0"
                        :key="Math.random() * 100000"
                    >
                        <div class="slide" v-for="image of card.imageUrls" :key="image"><img :src="image" /></div>
                    </ssr-carousel>
                </div>
            </div>
            <div class="card-image" v-else-if="card.imageUrl">
                <viewer :id="'imageViewer-' + card.id" :images="[card.imageUrl]">
                    <div class="image-preview" @click="show">
                        <img
                            :id="'img-' + card.id"
                            :src="card.imageUrl"
                            class="thumbnail"
                            style="object-fit: cover"
                        />
                        <md-icon v-if="hovered" class="preview-icon" @click="show"> visibility</md-icon>
                    </div>
                </viewer>
            </div>
            <div class="card-content">
                <div class="card-title">
                    {{ card.title }}
                </div>
                <div class="card-description" v-html="card.description" />
            </div>
        </div>
        <div class="buttons">
            <div
                class="single-button"
                :class="{ disabled }"
                v-for="(button, i) in card.buttons"
                :key="button.id"
                @click="
                        sendButtonMessage('GALLERY', {
                            cardId: card.id,
                            buttonId: button.id,
                            blockId,
                            payloadId,
                            buttonPayload: button.payload,
                            button: button,
                        })
                    "
            >
                <div class="single-button-text">{{ button.title }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { sendSocketMessage } from "../../../../../utils/socketStream";
import _ from "lodash";
import { mapState } from "vuex";
import Vue from "vue";
import SsrCarousel from "vue-ssr-carousel";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";

Vue.component("ssr-carousel", SsrCarousel);
Vue.use(Viewer);

export default {
    name: "GalleryImageCard",
    props: ["card", "current", "conversationId", "blockId", "payloadId", "uniqMessageId", "disabled"],
    computed: {
        ...mapState({
            siteId: (state) => _.get(state.site.site, "_id"),
        }),
    },
    data() {
        return {
            clickedButton: null,
            hovered: false,
            viewerInstance: null,
        };
    },
    mounted() {
        this.viewerInstance = new Viewer(document.getElementById('imageViewer-' + this.card.id), {
            inline: false,
            button: true,
            navbar: false,
            title: false,
            toolbar: true,
            tooltip: false,
            movable: false,
            zoomable: false,
            rotatable: false,
            scalable: false,
            transition: false,
        });
    },
    methods: {
        sendButtonMessage(type, payload) {
            if (this.disabled) return;
            this.clickedButton = payload.buttonId;
            sendSocketMessage("chatbot/v2 user-button-select", {
                siteId: this.siteId,
                conversationId: this.conversationId,
                uniqMessageId: this.uniqMessageId,
                type,
                payload,
            });
        },
        show() {
            if (this.viewerInstance) {
                this.viewerInstance.show();
            }
        },
    },
    beforeDestroy() {
        if (this.viewerInstance) {
            this.viewerInstance.destroy();
        }
    },
};
</script>

<style lang="scss">
.message.gallery-image-card {
    margin: 0 8px;
    transition: opacity 0.3s;

    &.opac {
        opacity: 0.6;
    }

    .card {
        border: 1px solid;
        border-radius: var(--sps-radius-md);
        overflow: hidden;
        width: 240px;
        border-color: rgb(219, 225, 232);
        background: rgb(255, 255, 255);

        .card-image {
            height: 180px;
            overflow: hidden;
            .image-slider,
            .ssr-carousel-slides,
            .slide {
                height: 170px;
                max-height: 170px;
            }

            .image-preview {
                height: 100%;
                width: 100%;

                img.thumbnail {
                    height: 100%;
                    object-fit: cover;
                    width: 100%;
                    background: transparent !important;
                    display: block;
                    max-width: 100%;
                }
            }

            .preview-icon {
                position: absolute;
            }

            .image-slider,
            .ssr-carousel-slides,
            .slide {
                height: 170px;
                max-height: 170px;
            }

            .image-wrapper {
                height: 100%;
                width: 100%;

                img {
                    height: 100%;
                    object-fit: cover;
                    width: 100%;
                    background: transparent !important;
                    display: block;
                    max-width: 100%;
                }
            }
        }

        .card-content {
            display: flex;
            flex-direction: column;
            padding: 0 20px 30px;

            .card-title {
                word-wrap: break-word;
                font-size: 16px;
                font-weight: 600;
                line-height: 20px;
                margin-top: 12px;
                white-space: normal;
                width: 100%;
                color: rgb(0, 0, 0);
                margin-bottom: 0 !important;
            }

            .card-description {
                word-wrap: break-word;
                font-size: 16px;
                line-height: 20px;
                margin-top: 12px;
                white-space: normal;
                color: rgb(0, 0, 0);
            }
        }
    }
    .buttons {
        display: flex;
        flex-direction: column;
        width: 100%;

        .single-button {
            align-items: center;
            cursor: pointer;
            display: flex;
            font-weight: 600;
            height: 45px;
            padding: 0 10px;
            transition: all 0.3s;
            background: var(--chatbot-button-color) !important;
            border: 1px solid var(--chatbot-button-text-color) !important;
            margin: 4px;
            border-radius: var(--sps-radius-sm);
            &.disabled {
                opacity: 0.5 !important;
                cursor: not-allowed;
            }
            &:hover {
                opacity: 0.8 !important;
                transform: scale(1.02);
                box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
            }

            .single-button-text {
                color: var(--chatbot-button-text-color) !important;
                overflow: hidden !important;
                text-align: center;
                text-overflow: ellipsis;
                //white-space: nowrap;
                width: 100%;
                font-size: 12px;
            }
        }
    }


}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/messages/chatbot/GalleryImageCard.vue